import StatusTag from "components/StatusTag";
import { AnalysisEventInternalListItem, ApplicationEventType } from "models/types";
import { ReactNode } from "react";

const eventTitleMapper: {
	types: ApplicationEventType[];
	displayFunction: (eventData: AnalysisEventInternalListItem) => ReactNode;
}[] = [
	{
		types: [ApplicationEventType.REMOVER_RESPONSABILIDADE, ApplicationEventType.ADICIONAR_COMENTARIO],
		displayFunction: (eventData) => <strong className="text-base">{`${eventData.typeLabel} - ${eventData.createdByGroup}`}</strong>
	},
	{
		types: [ApplicationEventType.SOLICITAR_ALTERACAO, ApplicationEventType.SOLICITACAO_REPROVADA, ApplicationEventType.SOLICITACAO_APROVADA],

		displayFunction: (eventData) =>
			eventData.applicationAnalysis && (
				<div className="flex row">
					<strong className="text-base">{eventData.typeLabel}</strong>
					<StatusTag eventType={eventData.type} status={eventData.applicationAnalysis.status} className="ml-2" small />
				</div>
			)
	}
];

function defaultTitleDisplay(eventData: AnalysisEventInternalListItem): ReactNode {
	return <strong className="text-base">{eventData.typeLabel}</strong>;
}

function getEventTitle(eventData: AnalysisEventInternalListItem): ReactNode {
	const { type } = eventData;
	const titleMapper = eventTitleMapper.find(({ types }) => !!types.find((t) => t === type));
	const displayFunction = titleMapper?.displayFunction ?? defaultTitleDisplay;
	return displayFunction(eventData);
}

const EventDisplayHelper = {
	defaultTitleDisplay,
	getEventTitle,
	eventTitleMapper
};

export default EventDisplayHelper;
